import { useState, useEffect } from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { getAuth, onAuthStateChanged, multiFactor } from "firebase/auth";

function getLoginRoute(path) {

  const p = path.toLowerCase();

  if (
    p.startsWith("/jobbank") ||
    p.startsWith("/jobbankjobs")
  ) {
    return "/jobbank/login";
  }

  if (
    p.startsWith("/cecp")
  ) {
    return "/jobbank/login";
  }

  if (
    p.startsWith("/events")
  ) {
    return "/jobbank/login";
  }

  if (
    p.startsWith("/profile")
  ) {
    return "/jobbank/login";
  }

  if (
    p.startsWith("/employer")
  ) {
    return "/jobbank/login";
  }

  return "/login";
}

const ProtectedRoute = ({ children }) => {
  const [status, setStatus] = useState("loading"); // "loading" | "unauthed" | "noMfa" | "ok"
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const auth = getAuth();
    
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        // Not signed in
        if (localStorage.getItem("accountDeleted") === "true") {
          localStorage.removeItem("accountDeleted");
          navigate("/accountdeleted");
        } else {
          setStatus("unauthed");
        }
        return;
      }

      // Refresh token to pick up any custom claims if you’re using them
      await user.getIdToken(true);
      const factors = multiFactor(user)?.enrolledFactors || [];

      setStatus(
          factors.length === 0
              ? "noMfa"
              : "ok"
      );
    });

    return () => unsubscribe();
  }, [navigate]);

  if (status === "loading") {
    return <div>Loading...</div>;
  }
  
    if (status === "unauthed") {

      return (
        <Navigate
          to={getLoginRoute(location.pathname)}
          state={{ from: location }}
          replace
        />
      );
    }

    if (status === "noMfa") {
      return <Navigate to="/security" />;
    }

    return children;
};

export default ProtectedRoute;